const BinIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg height={size} viewBox='0 0 16 16' width={size} xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M 10 1 H 6 V 2 H 10 V 1 Z M 2 3 V 4 H 3 V 14 C 3 14.6 3.4 15 4 15 H 12 C 12.6 15 13 14.6 13 14 V 4 H 14 V 3 H 2 Z M 4 14 V 4 H 12 V 14 H 4 Z M 6 6 H 7 V 12 H 6 V 6 Z M 10 6 H 9 V 12 H 10 V 6 Z'
        fillRule='evenodd'
        stroke='none'
      />
    </svg>
  );
};

export default BinIcon;
